import $ from 'jquery';
import Backbone from 'backbone';

export default Backbone.View.extend({
    selectors: {
        hiddenClass: 'is-hidden'
    },

    initialize: function () {
        this.$preloader = $('<span class="svg-preloader js-remote-validation" />');
    },

    show: function () {
        this.$el.parent().prepend(this.$preloader);
    },

    hide: function () {
        this.$preloader.remove();
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/validation/remotePreloaderView.js
 **/